import { types } from "../types/types";

export const setTerminado = (payload) => ({
  type: types.setTerminado,
  payload,
});
